module.exports = __webpack_public_path__ + "img/pelota-golf.09c45a61.png";